<template>
    <div>
        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-9rem">
                    <div>length</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Период вычисления средней линии, в тиках таймфрейма. Большее значение - более плавная кривая.'"></i></div>
                </div>
                <InputText type="text" v-model="value.length" class="w-4rem p-1 mb-1" />
            </div>
        </div>


        <div class="flex flex-row align-items-center mb-2">
            <div class="flex flex-row w-8rem">
                <div>speedToDown</div>
                <div class="ml-1 text-gray-500 cursor-pointer">
                    <i class="pi pi-question-circle"
                       v-tooltip.bottom="'Скорость изменения средней (угол наклона), при котором считается, что начался (или закончился) нисходящий тренд. Чем ближе число к 0 тем быстрее будет признано, что тренд начался (или закончился).'"></i></div>
            </div>
            <InputText type="text" v-model="value.speed" class="w-5rem p-1 mb-1" />
        </div>

    </div>
</template>

<script>
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";

export default {
    components: {InputText, Dropdown},
    props:{
        value: Object,
    },
    data(){
        return {

        }
    },
}
</script>
